"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hasUsedAllClauseTypesInSection_1 = require("./helpers/hasUsedAllClauseTypesInSection");
var store_1 = require("../store/store");
var owa_guid_1 = require("owa-guid");
var legacy_1 = require("satcheljs/lib/legacy");
var addNewClause = legacy_1.action('addNewClause')(function addNewClause(sectionType, clauseType, clauseValue) {
    // If user has maxed out on clause types (they have used every possible clause type already), then it's a no-op
    if (hasUsedAllClauseTypesInSection_1.default(sectionType)) {
        return;
    }
    var newClauseId = owa_guid_1.getGuid();
    if (sectionType == 'conditional') {
        store_1.default.inboxRulesEditState.conditionalClauseIds.push(newClauseId);
    }
    else if (sectionType == 'action') {
        store_1.default.inboxRulesEditState.actionClauseIds.push(newClauseId);
    }
    else if (sectionType == 'exception') {
        store_1.default.inboxRulesEditState.exceptionClauseIds.push(newClauseId);
    }
    else {
        throw new Error('Cannot add a clause id to a section that does not exists');
    }
    store_1.default.inboxRulesEditState.clauseMap.set(newClauseId, {
        clauseType: clauseType,
        clauseValue: clauseValue,
    });
});
exports.default = addNewClause;
//# sourceMappingURL=addNewClause.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/addNewClause.js
// module id = 2940
// module chunks = 2 90